let request;

export function resetRuntimeConfigCache() {
  request = undefined;
}

export function getRuntimeConfig(fetchImpl = fetch) {
  if (!request) {
    request = fetchImpl('/api/runtime-config').then(async (response) => {
      if (!response.ok) throw new Error(`Runtime configuration request failed (${response.status}).`);
      return response.json();
    }).catch((error) => {
      request = undefined;
      throw error;
    });
  }
  return request;
}
